// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://nameless-sierra-57223.herokuapp.com/api/',
  firebase: {
    apiKey: 'AIzaSyAAkzfu0PVSK97IMlOHAlWpup2MFOJZu4o',
    authDomain: 'piehotelodisha.firebaseapp.com',
    databaseURL: 'https://piehotelodisha.firebaseio.com',
    projectId: 'piehotelodisha',
    storageBucket: 'piehotelodisha.appspot.com',
    messagingSenderId: '885104351831',
    appId: '1:885104351831:web:e02731a8f18c254b826112',
    measurementId: 'G-YY7SHE7T94'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
